import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any; }
  Datetime: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  id: Scalars['ID']['output'];
};

export enum App {
  Gorgoroth = 'gorgoroth',
  Mountdoom = 'mountdoom'
}

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type CountResult = {
  __typename?: 'CountResult';
  count: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  notificationRead?: Maybe<Notification>;
  notificationReadAll: CountResult;
  saveSubscriptionPreferences: Array<SubscriptionPreference>;
  subscribe: Subscription;
  syncUser: User;
  unsubscribe?: Maybe<Scalars['String']['output']>;
  updateNotificationsFavorite: Array<Notification>;
  updateNotificationsRead: Array<Notification>;
};


export type MutationNotificationReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSaveSubscriptionPreferencesArgs = {
  input: Array<SubscriptionPreferenceInput>;
};


export type MutationSubscribeArgs = {
  input: SubscribeInput;
};


export type MutationUnsubscribeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateNotificationsFavoriteArgs = {
  input: UpdateNotificationsFavoriteInput;
};


export type MutationUpdateNotificationsReadArgs = {
  input: UpdateNotificationsReadInput;
};

export type Notification = {
  __typename?: 'Notification';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  data: Scalars['JSONObject']['output'];
  favoritedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['ID']['output'];
  readAt?: Maybe<Scalars['Datetime']['output']>;
  type: NotificationType;
};

export enum NotificationType {
  CompanyInviteAccepted = 'companyInviteAccepted',
  CompanyInviteRefused = 'companyInviteRefused',
  MaintenanceCanceled = 'maintenanceCanceled',
  MaintenanceCommented = 'maintenanceCommented',
  MaintenanceCompleted = 'maintenanceCompleted',
  MaintenanceCreated = 'maintenanceCreated',
  MaintenanceInProgress = 'maintenanceInProgress',
  MaintenanceOnNegotiation = 'maintenanceOnNegotiation',
  MaintenanceReported = 'maintenanceReported',
  MaintenanceResponseDeadlineAtRisk = 'maintenanceResponseDeadlineAtRisk',
  MaintenanceResponseDeadlineViolated = 'maintenanceResponseDeadlineViolated',
  MaintenanceScheduled = 'maintenanceScheduled',
  MaintenanceSolutionDeadlineAtRisk = 'maintenanceSolutionDeadlineAtRisk',
  MaintenanceSolutionDeadlineViolated = 'maintenanceSolutionDeadlineViolated',
  PendencyCompleted = 'pendencyCompleted',
  PendencyCreated = 'pendencyCreated',
  PendencyReplied = 'pendencyReplied',
  PendencyTransferred = 'pendencyTransferred',
  PendencyUpdated = 'pendencyUpdated',
  QuotationCreated = 'quotationCreated',
  StorageEmptyQuantity = 'storageEmptyQuantity',
  StorageEntry = 'storageEntry',
  StorageExternalTransfer = 'storageExternalTransfer',
  StorageInternalTransfer = 'storageInternalTransfer',
  StorageMinQuantity = 'storageMinQuantity',
  StorageMinQuantityAtRisk = 'storageMinQuantityAtRisk',
  StorageMinQuantityViolated = 'storageMinQuantityViolated',
  StorageRemoval = 'storageRemoval',
  TicketAccepted = 'ticketAccepted',
  TicketCanceled = 'ticketCanceled',
  TicketCommented = 'ticketCommented'
}

export type NotificationWhereInput = {
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  typeIn?: InputMaybe<Array<NotificationType>>;
};

export type Query = {
  __typename?: 'Query';
  me: User;
  notifications: Array<Notification>;
  notificationsFavoriteUnreadCount: CountResult;
  notificationsUnreadCount: CountResult;
  subscriptionPreferences: Array<SubscriptionPreference>;
};


export type QueryNotificationsArgs = {
  before?: InputMaybe<Scalars['Datetime']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NotificationWhereInput>;
};

export type SubscribeInput = {
  app: App;
  data: Scalars['JSONObject']['input'];
  type: SubscriptionType;
};

export type Subscription = {
  __typename?: 'Subscription';
  app: App;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  data: Scalars['JSONObject']['output'];
  id: Scalars['ID']['output'];
  type: SubscriptionType;
  userId: Scalars['ID']['output'];
};

export type SubscriptionPreference = {
  __typename?: 'SubscriptionPreference';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  type: NotificationType;
};

export type SubscriptionPreferenceInput = {
  enabled: Scalars['Boolean']['input'];
  type: NotificationType;
};

export enum SubscriptionType {
  Android = 'android',
  Browser = 'browser',
  Ios = 'ios'
}

export type UpdateNotificationsFavoriteInput = {
  ids: Array<Scalars['ID']['input']>;
  markAsFavorite: Scalars['Boolean']['input'];
};

export type UpdateNotificationsReadInput = {
  ids: Array<Scalars['ID']['input']>;
  markAsRead: Scalars['Boolean']['input'];
};

export type User = {
  __typename?: 'User';
  account: Account;
  createdAt: Scalars['Datetime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastSeen?: Maybe<Scalars['Datetime']['output']>;
  name: Scalars['String']['output'];
};

export type ListNotificationsQueryVariables = Exact<{
  where?: InputMaybe<NotificationWhereInput>;
  before?: InputMaybe<Scalars['Datetime']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListNotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'Notification', id: string, type: NotificationType, data: any, readAt?: any | null, createdAt?: any | null }> };

export type GetNotificationsUnreadCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationsUnreadCountQuery = { __typename?: 'Query', notificationsUnreadCount: { __typename?: 'CountResult', count: number } };

export type NotificationReadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NotificationReadMutation = { __typename?: 'Mutation', notificationRead?: { __typename?: 'Notification', id: string, readAt?: any | null } | null };

export type NotificationReadAllMutationVariables = Exact<{ [key: string]: never; }>;


export type NotificationReadAllMutation = { __typename?: 'Mutation', notificationReadAll: { __typename?: 'CountResult', count: number } };

export type NotificationsUnreadCountQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsUnreadCountQuery = { __typename?: 'Query', notificationsUnreadCount: { __typename?: 'CountResult', count: number } };

export type NotificationsFavoriteUnreadCountQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsFavoriteUnreadCountQuery = { __typename?: 'Query', notificationsFavoriteUnreadCount: { __typename?: 'CountResult', count: number } };

export type NotificationsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['Datetime']['input']>;
  where?: InputMaybe<NotificationWhereInput>;
}>;


export type NotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'Notification', id: string, type: NotificationType, data: any, readAt?: any | null, createdAt?: any | null, favoritedAt?: any | null }> };

export type UpdateNotificationsReadMutationVariables = Exact<{
  input: UpdateNotificationsReadInput;
}>;


export type UpdateNotificationsReadMutation = { __typename?: 'Mutation', updateNotificationsRead: Array<{ __typename?: 'Notification', id: string, readAt?: any | null }> };

export type UpdateNotificationsFavoriteMutationVariables = Exact<{
  input: UpdateNotificationsFavoriteInput;
}>;


export type UpdateNotificationsFavoriteMutation = { __typename?: 'Mutation', updateNotificationsFavorite: Array<{ __typename?: 'Notification', id: string, favoritedAt?: any | null }> };

export type SubscriptionPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionPreferencesQuery = { __typename?: 'Query', subscriptionPreferences: Array<{ __typename?: 'SubscriptionPreference', id: string, type: NotificationType, enabled: boolean }> };

export type SaveSubscriptionPreferencesMutationVariables = Exact<{
  input: Array<SubscriptionPreferenceInput> | SubscriptionPreferenceInput;
}>;


export type SaveSubscriptionPreferencesMutation = { __typename?: 'Mutation', saveSubscriptionPreferences: Array<{ __typename?: 'SubscriptionPreference', id: string }> };

export const ListNotificationsDocument = gql`
    query listNotifications($where: NotificationWhereInput, $before: Datetime, $take: Int) {
  notifications(where: $where, before: $before, take: $take) {
    id
    type
    data
    readAt
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListNotificationsGQL extends Apollo.Query<ListNotificationsQuery, ListNotificationsQueryVariables> {
    override document = ListNotificationsDocument;
    override client = 'mordu';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNotificationsUnreadCountDocument = gql`
    query getNotificationsUnreadCount {
  notificationsUnreadCount {
    count
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNotificationsUnreadCountGQL extends Apollo.Query<GetNotificationsUnreadCountQuery, GetNotificationsUnreadCountQueryVariables> {
    override document = GetNotificationsUnreadCountDocument;
    override client = 'mordu';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NotificationReadDocument = gql`
    mutation notificationRead($id: ID!) {
  notificationRead(id: $id) {
    id
    readAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NotificationReadGQL extends Apollo.Mutation<NotificationReadMutation, NotificationReadMutationVariables> {
    override document = NotificationReadDocument;
    override client = 'mordu';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NotificationReadAllDocument = gql`
    mutation notificationReadAll {
  notificationReadAll {
    count
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NotificationReadAllGQL extends Apollo.Mutation<NotificationReadAllMutation, NotificationReadAllMutationVariables> {
    override document = NotificationReadAllDocument;
    override client = 'mordu';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NotificationsUnreadCountDocument = gql`
    query notificationsUnreadCount {
  notificationsUnreadCount {
    count
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NotificationsUnreadCountGQL extends Apollo.Query<NotificationsUnreadCountQuery, NotificationsUnreadCountQueryVariables> {
    override document = NotificationsUnreadCountDocument;
    override client = 'mordu';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NotificationsFavoriteUnreadCountDocument = gql`
    query notificationsFavoriteUnreadCount {
  notificationsFavoriteUnreadCount {
    count
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NotificationsFavoriteUnreadCountGQL extends Apollo.Query<NotificationsFavoriteUnreadCountQuery, NotificationsFavoriteUnreadCountQueryVariables> {
    override document = NotificationsFavoriteUnreadCountDocument;
    override client = 'mordu';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NotificationsDocument = gql`
    query notifications($take: Int, $before: Datetime, $where: NotificationWhereInput) {
  notifications(take: $take, before: $before, where: $where) {
    id
    type
    data
    readAt
    createdAt
    favoritedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NotificationsGQL extends Apollo.Query<NotificationsQuery, NotificationsQueryVariables> {
    override document = NotificationsDocument;
    override client = 'mordu';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateNotificationsReadDocument = gql`
    mutation updateNotificationsRead($input: UpdateNotificationsReadInput!) {
  updateNotificationsRead(input: $input) {
    id
    readAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateNotificationsReadGQL extends Apollo.Mutation<UpdateNotificationsReadMutation, UpdateNotificationsReadMutationVariables> {
    override document = UpdateNotificationsReadDocument;
    override client = 'mordu';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateNotificationsFavoriteDocument = gql`
    mutation updateNotificationsFavorite($input: UpdateNotificationsFavoriteInput!) {
  updateNotificationsFavorite(input: $input) {
    id
    favoritedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateNotificationsFavoriteGQL extends Apollo.Mutation<UpdateNotificationsFavoriteMutation, UpdateNotificationsFavoriteMutationVariables> {
    override document = UpdateNotificationsFavoriteDocument;
    override client = 'mordu';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubscriptionPreferencesDocument = gql`
    query subscriptionPreferences {
  subscriptionPreferences {
    id
    type
    enabled
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SubscriptionPreferencesGQL extends Apollo.Query<SubscriptionPreferencesQuery, SubscriptionPreferencesQueryVariables> {
    override document = SubscriptionPreferencesDocument;
    override client = 'mordu';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveSubscriptionPreferencesDocument = gql`
    mutation saveSubscriptionPreferences($input: [SubscriptionPreferenceInput!]!) {
  saveSubscriptionPreferences(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveSubscriptionPreferencesGQL extends Apollo.Mutation<SaveSubscriptionPreferencesMutation, SaveSubscriptionPreferencesMutationVariables> {
    override document = SaveSubscriptionPreferencesDocument;
    override client = 'mordu';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }